import React from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import {Overlay} from '../overlay/overlay';

import styles from '../../dialog.module.styl';

import type {OverlayProps} from '../overlay/overlay';
import type {ComponentProps} from 'react';

const classNames = withCssModule(styles);

type Props = {
    /**
     * Native `<div>` props forwarded to the inner panel element (e.g. `className`,
     * `style`, `data-testid`). The panel receives the `dialog` CSS class plus any
     * class provided here.
     */
    wrapperProps?: ComponentProps<'div'>,
} & OverlayProps;

/**
 * Core building block for modal dialogs in the `@pb/kit-component-dialog-v2` package.
 *
 * Renders an `Overlay` (backdrop + focus trap + portal) with `role="dialog"` and
 * wraps `children` in a styled panel div. Use inside `DialogMain` controlled by
 * `useDialogFloating` to manage the open/close lifecycle.
 *
 * Compose with `DialogHeader`, `DialogMain`, and `DialogFooter` for standard
 * modal layouts. For a ready-made confirmation flow use `AlertDialog` instead.
 *
 * @see [Storybook]{@link https://storybook.dev.pitchbookdata.com/?path=/docs/overlays-dialog--documentation}
 */
export function Dialog({
    wrapperProps,
    children,
    ...props
}: Props) {

    return (
        <Overlay {...props} roleProps={{...props?.roleProps, enabled: true}}>
            <div
                {...wrapperProps}
                className={classNames('dialog', wrapperProps?.className)}>
                {children}
            </div>
        </Overlay>
    );
}
